import { useQuery } from '@tanstack/react-query';

import { secretService } from '@/services/secret-service';
import { isEmptyUUID, type UUID } from '@/utils/uuid';

import { secretQueryKeys } from './query-keys';

/**
 * Hook to list all secret templates for a tenant.
 * Returns a react-query query with the list of secret templates.
 */
export function useListSecretTemplates(tenantId?: UUID) {
  return useQuery({
    queryKey: secretQueryKeys.templateList(tenantId),
    queryFn: () => {
      if (isEmptyUUID(tenantId)) throw new Error('Missing tenant id');
      return secretService.listSecretTemplates(tenantId!);
    },
    enabled: !isEmptyUUID(tenantId),
  });
}
